import $ from 'jquery';

const BILLETTO_SCRIPT_URL = 'https://billetto.se/embed.js'


export default class EventBookingHandler {
    constructor() {
        this.init();
    }

    init() {
        if ($('.billetto-btn').length > 0) {
            this.loadBillettoScript();
        }
    }

    loadBillettoScript() {
        var script = document.createElement('script');
        script.src = BILLETTO_SCRIPT_URL;
        (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
        script.onload = this.buttonInit;
    }

    buttonInit() {
    }
}



// WEBPACK FOOTER //
// ./www/wp-content/themes/accelerator/assets/scripts/src/App/EventBooking/EventBookingHandler.js